export const DEFAULT_TIMEZONE = "GMT";
export const PACIFIC_TIMEZONE = "America/Los_Angeles";
export const AT_STATION = "AT_STATION";
export const INDUCT = "INDUCT";
export const DELIVERY = "Delivery";
export const RETURN_PICKUP = "CReturns";
export const MFN_PICKUP = "MFNPickup";
export const MANIFEST = "MANIFEST";
export const PENDING_PICKUP = "PENDING_PICKUP";
export const PENDING_RETURN_PICKUP = "PENDING_RETURN_PICKUP";
export const SEARCH_UI_TRACKING_ID_LIMIT = 1000;
export const GAMEDAY_PACKAGE_ID_PREFIX = "GMD";
export const AMAZON_SUFFIX = "@amazon.com";
export const PROD = "prod";
export const MASTER = "master";
export const GAMMA = "gamma";
export const INTEG = "integ";
export const BETA = "beta";
export const DASH_DELIMITER = "-"
export const UNKNOWN = "Unknown";
export const ONE_HOUR = "onehour";
export const FIVE_AND_THREE_HOUR = "fiveandthreehour";
export const FIVE_AND_THREE_HOUR_BUTTON_TEXT = "5h & 3h";
export const ONE_HOUR_BUTTON_TEXT = "1 h";
export const DWELL_VIEW = "DWELL_VIEW";
export const DWELL_DETAILED_VIEW_PACKAGE_LIST_SIZE = 1000;
export const DWELL_FILTER_STATE_KEY = "dwellFilterState";
export const DWELL_TIME = "Dispatch Time"
export const TRACKING_ID = "Route ID"
export const STATE = "Location"
export const LAST_SCAN = "Status"
export const ASSOCIATE = "Progress"
export const LOCATION = "Driver"
export const PACKAGE_TYPE = "Package Type"
export const PACKAGE_TYPE_CORE = "CORE"
export const PACKAGE_TYPE_GROCERY = "GROCERY"
export const DEFAULT_MESSAGE_FOR_DWELL_PAGE_ALERT = "Only 1,000 packages are currently displayed. To view all packages, please export to CSV"
export const DWELL_DETAILED_VIEW_TABLE_COLUMNS = [
    DWELL_TIME,
    TRACKING_ID,
    STATE,
    LAST_SCAN,
    ASSOCIATE,
    LOCATION,
    PACKAGE_TYPE
]

export const DWELL_FILTER_ACTIONS = {
    RECEIVE_FILTER_DATA: "RECEIVE_FILTER_DATA",
    SELECT_PACKAGE_STATUS: "SELECT_PACKAGE_STATUS",
    SELECT_PACKAGE_SUB_STATUS_TABLE_FILTER: "SELECT_PACKAGE_SUB_STATUS_TABLE_FILTER",
    SELECT_PACKAGE_TYPE: "SELECT_PACKAGE_TYPE",
    SELECT_PACKAGE_SCHEDULED_DELIVERY_WINDOW: "SELECT_PACKAGE_SCHEDULED_DELIVERY_WINDOW",
    SELECT_PACKAGE_STATUS_TILE: "SELECT_PACKAGE_STATUS_TILE",
    SELECT_EXCEPTION_DWELLING: "SELECT_EXCEPTION_DWELLING",
    UNLOAD_VIEW: "UNLOAD_VIEW",
    REMOVE_ALL_FILTER: "REMOVE_ALL_FILTER",
    REMOVE_FILTER: "REMOVE_FILTER",
    LOAD_FILTERS: "LOAD_FILTERS",
    SELECT_TILE: "SELECT_TILE"
}

export const STRINGS = {
    EMPTY:  "",
    TIMEOUT:  "timeout"
}
export const REGION = {
    NA: "NA",
    EU: "EU",
    IN: "IN",
    FE: "FE"
}
export const ENVIRONMENT = {
    DEV: "development",
    TEST: "test",
    PROD: "production"
}
export const STAGE = {
    DEV: "dev",
    BETA: "beta",
    GAMMA: "gamma",
    PROD: "prod"
}
export const REALM = {
    NA: "NAAmazon",
    EU: "EUAmazon",
    IN: "EUAmazon",
    FE: "FEAmazon"
}
export const DATE_TIME_FORMAT = {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
    hour:'2-digit',
    minute:'2-digit',
    second:'2-digit',
    timeZoneName: 'short',
    hourCycle:'h24'
}
export const FILTER_DEFAULT =  {
    isOptionsVisible : false,
    isApplyFilterClicked : false,
    cycles : [],
    CPT: [],
    deliveryWindow : [],
    startPDD : "",
    endPDD : "",
    shipDateStart : "",
    shipDateEnd : "",
    dwellStart : "30",
    dwellEnd : "0",
    packageTypes : [],
    packageTypes_Reverse : [],
    packageStatuses : [],
    dwellStartTimeUnit : "Day",
    dwellEndTimeUnit : "Day",
    sameDay : false,
    stationArrivalTime : [],
    leg : "Forward",
    eadSection : false,
    lastUpdatedStart : "",
    lastUpdatedEnd : "",
    page : "",
    shipOption : ""
}
export const PAGE_HEADERS = {
    DWELL: {
        tab: "dwell.tabHeading",
        tabAlt: "Package Summary",
        head: "dwell.heading",
        headAlt: "Dwell",
        desc: "dwell.description",
        descAlt: "This table shows the total number and status of packages in the station by cycle/scheduled delivery window"
    },
    AGEING: {
        tab: "aging.tabHeading",
        tabAlt: "Package Summary",
        head: "aging.heading",
        headAlt: "Ageing",
        desc: "aging.description",
        descAlt: "This table shows the number of packages that have spent more than one day " +
            "in a particular status. You can manually scrub the in-station and on-road information"
    },
    RTS: {
        tab: "rts.tabHeading",
        tabAlt: "Package Summary",
        head: "rts.heading",
        headAlt: "RTS",
        desc: "rts.description",
        descAlt: "This table shows the current status and number of packages returning to the station"
    },
    SEARCH: {
        tab: "search.tabHeading",
        tabAlt: "Package Summary",
        head: "search.heading",
        headAlt: "Search",
        desc: "search.description",
        descAlt: "Search for more information about packages, containers, or associates"
    },
}

export const RTS_PAGE_HEADER_METRIC = {
    "Disputed Scan": {
        metricVisibleName: "Disputed Scans",
        metricVisibleUnit: "Packages"
    }
}

export const FEATURES = {
    ASL_LATEST_PROTOCOL: "isASLLatestProtocol",
    DEPART_FILTERING_ENABLED: "isDepartFiltersEnabled",
    IS_CPT_FILTER_ENABLED: "isCPTFilterEnabled",
    IS_VIRTUAL_SCRUB_BUTTON_DISABLED: "DISABLE_VIRTUAL_SCRUB",
    IS_GAMEDAY_PACKAGE_HISTORY_VISIBILITY_ENABLED: "isGamedayPackageHistoryVisibilityEnabled",
    IS_BUYBACK_VISIBILITY_ENABLED: "isBuyBackVisibilityEnabled",
    IS_DWELL_DETAILED_VIEW_FOR_SSD_ENABLED: "isDwellDetailedViewForSsdEnabled",
    IS_TOGGLE_FOR_DWELL_DETAILED_VIEW_ENABLED: "isToggleForDwellDetailedViewEnabled",
    IS_SHIP_OPTION_FILTER_FOR_METRICS_API_ENABLED: "isShipOptionFilterForMetricsApiEnabled",
    IS_SHIP_OPTION_FILTER_FOR_EXPORT_API_ENABLED: "isShipOptionFilterForExportApiEnabled",
    IS_SHIP_OPTION_FILTER_FOR_DRILL_DOWN_API_ENABLED: "isShipOptionFilterForDrillDownApiEnabled",
    IS_PACKAGE_TYPE_COLUMN_DWELL_ENABLED: "isPackageTypeColumnDwellEnabled",
    IS_BUYBACK_VISIBILITY_FOR_AGEINGTAB_ENABLED : "isBuyBackVisibilityForAgeingTabEnabled",
    IS_PACKAGE_SEARCH_INTERNAL_PDD_ENABLED: "isPackageSearchInternalPDDEnabled",
    IS_IPDD_NO_CONVERSION_ENABLED: "isIPDDNoConversionEnabled",
    IS_SHIPPER_NAME_ENABLED: "isShipperNameEnabled",
    IS_CUSTOMER_NOTE_VISIBLE: "isCustomerNoteVisible",
    IS_EWASTE_WTN_ENABLED: "isEWasteWtnEnabled",
    IS_ASSOCIATE_SEARCH_DIAL_DOWN: "associateSearchDialDown",
    IS_RTS_CALENDAR_DAY_DEFAULT_ENABLED: "isRtsCalendarDayDefaultEnabled",
    IS_RTS_WATERFALL_CLEANUP_ENABLED: "isRtsWaterfallCleanupEnabled"
}

export const WASTE_TRANSFER_NOTE = "Waste Transfer Note";

export const ACTION_TYPE = {
    GET_FEATURES_STATUS: "GET_FEATURES_STATUS"
}

export const EXCHANGE_TYPE = {
    BB : "BuyBack",
    H2H : "H2H"
}

export const ITEM_STATUS = {
    MISSING: 'Missing',
    PARTIAL_DELIVERY: 'Partial Delivery',
    DAMAGED_RETURN: 'Damaged Return',
    DISPOSED: 'Disposed',
    HELD: 'Held'
};

export const HTTP_STATUS_CODE = {
    UNAUTHORISED_RESPONSE_CODE: 401
}

export const NO_FILTER_TAG_LIST = ['data', 'selectedPackageStatusListTile']


// WEBPACK FOOTER //
// ./src/commons/constants/CommonConstants.js